/**
 * video-reels.js — Video Reels Section with Popup Gallery
 * Place in: assets/video-reels.js
 * FIXED: Consolidated duplicate functions, auto-play working
 */
(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 599;

  // Popup state
  var popupState = {
    isOpen: false,
    currentIndex: 0,
    totalSlides: 0,
    slides: [],
    video: null,
    section: null,
    animationFrame: null,
    isAnimating: false,
    swipeDirection: null
  };

  function init() {
    if (typeof Splide === 'undefined') {
      setTimeout(init, 80);
      return;
    }

    document.querySelectorAll('.video-reels__splide').forEach(initSlider);
    initPopupGallery();
  }

  /* ───────────────────────────────────────────────────────────
     SLIDER INIT
  ─────────────────────────────────────────────────────────── */
  function initSlider(sliderEl) {
    var section = sliderEl.closest('.video-reels-section');
    if (!section) return;
    
    var desktopGap = parseInt(section.dataset.slideGap, 10) || 16;
    var mobileGap = parseInt(section.dataset.slideGapMobile, 10) || 12;
    var desktopSlides = parseInt(section.dataset.slidesDesktop, 10) || 0;
    var mobileSlides = parseInt(section.dataset.slidesMobile, 10) || 0;
    var desktopPerMove = parseInt(section.dataset.perMoveDesktop, 10) || 1;
    var mobilePerMove = parseInt(section.dataset.perMoveMobile, 10) || 1;
    var showArrowsDesktop = section.dataset.arrowsDesktop === 'true';
    var showArrowsMobile = section.dataset.arrowsMobile === 'true';
    var showPaginationDesktop = section.dataset.paginationDesktop === 'true';
    var showPaginationMobile = section.dataset.paginationMobile === 'true';

    var splideOptions = {
      type        : 'loop',
      focus       : 'center',
      gap         : desktopGap + 'px',
      perMove     : desktopPerMove,
      pagination  : showPaginationDesktop,
      arrows      : showArrowsDesktop,
      speed       : 400,
      drag        : true,
      snap        : true,
      updateOnMove: true,
      trimSpace   : false,
      flickPower  : 300,
      flickMaxPages: 1,
      breakpoints : {
        [MOBILE_BREAKPOINT]: { 
          gap: mobileGap + 'px',
          perMove: mobilePerMove,
          arrows: showArrowsMobile,
          pagination: showPaginationMobile
        }
      }
    };

    if (desktopSlides > 0) {
      splideOptions.perPage = desktopSlides;
      splideOptions.autoWidth = false;
      splideOptions.breakpoints[MOBILE_BREAKPOINT].perPage = mobileSlides > 0 ? mobileSlides : 1;
      splideOptions.breakpoints[MOBILE_BREAKPOINT].autoWidth = false;
    } else {
      splideOptions.autoWidth = true;
      if (mobileSlides > 0) {
        splideOptions.breakpoints[MOBILE_BREAKPOINT].perPage = mobileSlides;
        splideOptions.breakpoints[MOBILE_BREAKPOINT].autoWidth = false;
      } else {
        splideOptions.breakpoints[MOBILE_BREAKPOINT].autoWidth = true;
      }
    }

    applySlideWidths(sliderEl, section, desktopSlides, mobileSlides);

    var splide = new Splide(sliderEl, splideOptions);

    splide.mount();

    updateArrowClasses(section, showArrowsDesktop, showArrowsMobile);
    updatePaginationClasses(section, showPaginationDesktop, showPaginationMobile);

    splide.on('move', function () {
      pauseAllInSlider(sliderEl);
    });

    splide.on('moved', function (newIndex) {
      setTimeout(function() {
        autoPlayActiveSlide(sliderEl);
      }, 100);
    });

    splide.on('active', function(slideComponent) {
      sliderEl.querySelectorAll('[data-play-btn]').forEach(function(btn) {
        btn.classList.remove('is-playing');
      });
      
      var slide = slideComponent.slide;
      if (slide && !slide.classList.contains('splide__slide--clone')) {
        setTimeout(function() {
          playVideoInSlide(slide);
        }, 150);
      }
    });

    // Initial auto-play
    setTimeout(function () {
      autoPlayActiveSlide(sliderEl);
    }, 500);

    initAllSlideClicks(sliderEl, section, splide);
    
    sliderEl.querySelectorAll('.video-reels__slide:not(.splide__slide--clone)').forEach(function(slide) {
      initSlideControls(slide);
    });
    
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        applySlideWidths(sliderEl, section, desktopSlides, mobileSlides);
        splide.refresh();
      }, 250);
    });
  }

  /* ───────────────────────────────────────────────────────────
     Initialize click handlers for ALL slides
  ─────────────────────────────────────────────────────────── */
  function initAllSlideClicks(sliderEl, section, splide) {
    var allSlides = sliderEl.querySelectorAll('.video-reels__slide');
    
    allSlides.forEach(function(slide) {
      var videoContainer = slide.querySelector('[data-video-trigger]');
      
      if (videoContainer) {
        videoContainer.addEventListener('click', function(e) {
          if (e.target.closest('[data-play-btn]') || 
              e.target.closest('[data-sound-btn]') || 
              e.target.closest('.video-reels-product-card')) {
            return;
          }
          
          var slideIndex = getSlideIndex(slide, sliderEl);
          
          if (slideIndex !== -1) {
            openPopup(section, slideIndex);
          }
        });
      }
    });
  }

  /* ───────────────────────────────────────────────────────────
     Get correct slide index (handles clones)
  ─────────────────────────────────────────────────────────── */
  function getSlideIndex(slide, sliderEl) {
    var dataIndex = slide.getAttribute('data-slide-index');
    if (dataIndex !== null) {
      return parseInt(dataIndex, 10);
    }
    
    if (slide.classList.contains('splide__slide--clone')) {
      var video = slide.querySelector('.video-reels__video');
      var videoSrc = video ? (video.src || video.querySelector('source')?.src) : null;
      var productCard = slide.querySelector('.video-reels-product-card');
      var productTitle = productCard ? productCard.querySelector('.video-reels-product-card__title')?.textContent : null;
      
      var originalSlides = sliderEl.querySelectorAll('.video-reels__slide:not(.splide__slide--clone)');
      
      for (var i = 0; i < originalSlides.length; i++) {
        var origVideo = originalSlides[i].querySelector('.video-reels__video');
        var origVideoSrc = origVideo ? (origVideo.src || origVideo.querySelector('source')?.src) : null;
        var origProductCard = originalSlides[i].querySelector('.video-reels-product-card');
        var origProductTitle = origProductCard ? origProductCard.querySelector('.video-reels-product-card__title')?.textContent : null;
        
        if ((videoSrc && videoSrc === origVideoSrc) || 
            (productTitle && productTitle === origProductTitle)) {
          return i;
        }
      }
      
      var allSlides = sliderEl.querySelectorAll('.video-reels__slide:not(.splide__slide--clone)');
      var cloneIndex = Array.from(sliderEl.querySelectorAll('.splide__slide--clone')).indexOf(slide);
      
      if (cloneIndex !== -1) {
        return cloneIndex % allSlides.length;
      }
    }
    
    var nonCloneSlides = sliderEl.querySelectorAll('.video-reels__slide:not(.splide__slide--clone)');
    var index = Array.from(nonCloneSlides).indexOf(slide);
    
    return index !== -1 ? index : 0;
  }

  /* ───────────────────────────────────────────────────────────
     APPLY SLIDE WIDTHS
  ─────────────────────────────────────────────────────────── */
  function applySlideWidths(sliderEl, section, desktopSlides, mobileSlides) {
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    var slides = sliderEl.querySelectorAll('.splide__slide');
    
    var desktopWidthPercent = parseInt(section.dataset.videoWidth, 10) || 22;
    var mobileWidthPercent = parseInt(section.dataset.videoWidthMobile, 10) || 70;

    slides.forEach(function(slide) {
      if (isMobile) {
        if (mobileSlides === 0) {
          slide.style.width = mobileWidthPercent + '%';
          slide.style.minWidth = '150px';
          slide.style.maxWidth = '300px';
        } else {
          slide.style.width = '';
          slide.style.minWidth = '';
          slide.style.maxWidth = '';
        }
      } else {
        if (desktopSlides === 0) {
          slide.style.width = desktopWidthPercent + '%';
          slide.style.minWidth = '180px';
          slide.style.maxWidth = '400px';
        } else {
          slide.style.width = '';
          slide.style.minWidth = '';
          slide.style.maxWidth = '';
        }
      }
    });
  }

  /* ───────────────────────────────────────────────────────────
     UPDATE ARROW CLASSES
  ─────────────────────────────────────────────────────────── */
  function updateArrowClasses(section, showDesktop, showMobile) {
    section.classList.remove('video-reels--arrows-all', 'video-reels--arrows-desktop-only', 
                             'video-reels--arrows-mobile-only', 'video-reels--arrows-none');
    if (showDesktop && showMobile) {
      section.classList.add('video-reels--arrows-all');
    } else if (showDesktop) {
      section.classList.add('video-reels--arrows-desktop-only');
    } else if (showMobile) {
      section.classList.add('video-reels--arrows-mobile-only');
    } else {
      section.classList.add('video-reels--arrows-none');
    }
  }

  /* ───────────────────────────────────────────────────────────
     UPDATE PAGINATION CLASSES
  ─────────────────────────────────────────────────────────── */
  function updatePaginationClasses(section, showDesktop, showMobile) {
    section.classList.remove('video-reels--pagination-all', 'video-reels--pagination-desktop-only', 
                             'video-reels--pagination-mobile-only', 'video-reels--pagination-none');
    if (showDesktop && showMobile) {
      section.classList.add('video-reels--pagination-all');
    } else if (showDesktop) {
      section.classList.add('video-reels--pagination-desktop-only');
    } else if (showMobile) {
      section.classList.add('video-reels--pagination-mobile-only');
    } else {
      section.classList.add('video-reels--pagination-none');
    }
  }

  /* ───────────────────────────────────────────────────────────
     INIT SLIDE CONTROLS (Play/Pause, Sound, ATC)
  ─────────────────────────────────────────────────────────── */
  function initSlideControls(slide) {
    var video = slide.querySelector('.video-reels__video');
    var playBtn = slide.querySelector('[data-play-btn]');
    var soundBtn = slide.querySelector('[data-sound-btn]');

    if (!video) return;

    // Ensure initial state is muted
    video.muted = true;

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        togglePlay(video, playBtn);
      });
    }

    if (soundBtn) {
      // Ensure initial button state is muted
      soundBtn.dataset.muted = 'true';
      
      soundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleSound(video, soundBtn);
      });
    }

    var atcForm = slide.querySelector('.video-reels-product-card__atc-form');
    if (atcForm) {
      atcForm.addEventListener('submit', handleAtc);
    }

    var quickCartBtn = slide.querySelector('.video-reels-product-card__atc-btn--variants');
    if (quickCartBtn) {
      quickCartBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        quickCartBtn.classList.add('is-loading');
        setTimeout(function() {
          quickCartBtn.classList.remove('is-loading');
        }, 2000);
      });
    }
  }

  /* ───────────────────────────────────────────────────────────
     POPUP GALLERY FUNCTIONALITY
  ─────────────────────────────────────────────────────────── */
  function initPopupGallery() {
    document.querySelectorAll('[data-video-popup]').forEach(function(popup) {
      var section = popup.closest('.video-reels-section');
      
      // Close buttons
      popup.querySelectorAll('[data-popup-close]').forEach(function(closeBtn) {
        closeBtn.addEventListener('click', function() {
          closePopup(popup);
        });
      });

      // Navigation buttons
      var prevBtn = popup.querySelector('[data-popup-prev]');
      var nextBtn = popup.querySelector('[data-popup-next]');
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          navigatePopup(popup, -1, 'up');
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          navigatePopup(popup, 1, 'down');
        });
      }

      // Play/Pause button in popup
      var playBtn = popup.querySelector('[data-popup-play]');
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          togglePopupPlayPause(popup);
        });
      }

      // Mute button in popup
      var muteBtn = popup.querySelector('[data-popup-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function() {
          togglePopupMute(popup);
        });
      }

      // Progress bar click to seek
      var progressContainer = popup.querySelector('.video-reels-popup__progress-container');
      if (progressContainer) {
        progressContainer.addEventListener('click', function(e) {
          e.stopPropagation();
          if (!popupState.video || !popupState.video.duration) return;
          
          var rect = progressContainer.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          var percent = Math.max(0, Math.min(1, clickX / rect.width));
          
          popupState.video.currentTime = percent * popupState.video.duration;
          
          var progressBar = popup.querySelector('[data-popup-progress]');
          if (progressBar) {
            progressBar.style.width = (percent * 100) + '%';
          }
        });
      }

      // Thumbnail navigation
      popup.querySelectorAll('[data-popup-thumb]').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var index = parseInt(thumb.dataset.popupThumb, 10);
          var direction = index > popupState.currentIndex ? 'down' : 'up';
          goToPopupSlide(popup, index, direction);
        });
      });

      // Keyboard navigation
      document.addEventListener('keydown', function(e) {
        if (!popupState.isOpen) return;
        
        switch(e.key) {
          case 'Escape':
            closePopup(popup);
            break;
          case 'ArrowUp':
            e.preventDefault();
            navigatePopup(popup, -1, 'up');
            break;
          case 'ArrowDown':
            e.preventDefault();
            navigatePopup(popup, 1, 'down');
            break;
          case 'ArrowLeft':
            navigatePopup(popup, -1, 'up');
            break;
          case 'ArrowRight':
            navigatePopup(popup, 1, 'down');
            break;
          case ' ':
            e.preventDefault();
            togglePopupPlayPause(popup);
            break;
          case 'm':
          case 'M':
            togglePopupMute(popup);
            break;
        }
      });

      // Vertical swipe support for mobile
      initVerticalSwipeSupport(popup);
      
      // Mouse wheel support for desktop
      initMouseWheelSupport(popup);
    });
  }

  /* ───────────────────────────────────────────────────────────
     OPEN POPUP
  ─────────────────────────────────────────────────────────── */
  function openPopup(section, index) {
    var popup = section.querySelector('[data-video-popup]');
    if (!popup) return;

    var slides = section.querySelectorAll('.video-reels__slide:not(.splide__slide--clone)');
    
    if (index < 0 || index >= slides.length) {
      index = 0;
    }
    
    popupState.isOpen = true;
    popupState.currentIndex = index;
    popupState.totalSlides = slides.length;
    popupState.slides = Array.from(slides);
    popupState.section = section;
    popupState.isAnimating = false;

    var sliderEl = section.querySelector('.video-reels__splide');
    if (sliderEl) {
      pauseAllInSlider(sliderEl);
    }

    updatePopupCounter(popup);
    loadPopupVideo(popup, index, 'none');

    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('video-reels-popup-open');
    document.body.style.overflow = 'hidden';
  }

  /* ───────────────────────────────────────────────────────────
     CLOSE POPUP
  ─────────────────────────────────────────────────────────── */
  function closePopup(popup) {
    popupState.isOpen = false;
    popupState.isAnimating = false;

    if (popupState.video) {
      popupState.video.pause();
      popupState.video = null;
    }

    if (popupState.animationFrame) {
      cancelAnimationFrame(popupState.animationFrame);
    }

    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('video-reels-popup-open');
    document.body.style.overflow = '';

    var videoWrapper = popup.querySelector('[data-popup-video-wrapper]');
    if (videoWrapper) {
      videoWrapper.innerHTML = '';
    }

    var productWrapper = popup.querySelector('[data-popup-product]');
    if (productWrapper) {
      productWrapper.innerHTML = '';
    }

    var playBtn = popup.querySelector('[data-popup-play]');
    if (playBtn) {
      playBtn.classList.remove('is-playing');
    }

    // Reset popup mute button state
    var popupMuteBtn = popup.querySelector('[data-popup-mute]');
    if (popupMuteBtn) {
      popupMuteBtn.setAttribute('data-muted', 'false');
    }

    if (popupState.section) {
      var sliderEl = popupState.section.querySelector('.video-reels__splide');
      if (sliderEl) {
        // Reset ALL videos to muted state and reset ALL sound buttons
        resetAllSoundStates(sliderEl);
        
        setTimeout(function() {
          autoPlayActiveSlide(sliderEl);
        }, 300);
      }
    }
  }

  /* ───────────────────────────────────────────────────────────
     LOAD VIDEO IN POPUP - With vertical animation
  ─────────────────────────────────────────────────────────── */
  function loadPopupVideo(popup, index, direction) {
    var slide = popupState.slides[index];
    if (!slide) return;

    var videoWrapper = popup.querySelector('[data-popup-video-wrapper]');
    var productWrapper = popup.querySelector('[data-popup-product]');
    var videoContainer = popup.querySelector('.video-reels-popup__video-container');
    var sourceVideo = slide.querySelector('.video-reels__video');
    var sourceProductCard = slide.querySelector('.video-reels-product-card');
    var playBtn = popup.querySelector('[data-popup-play]');
    var muteBtn = popup.querySelector('[data-popup-mute]');

    // Add animation class based on direction
    if (direction && direction !== 'none' && videoContainer) {
      var animClass = direction === 'down' ? 'slide-in-from-bottom' : 'slide-in-from-top';
      videoContainer.classList.remove('slide-in-from-top', 'slide-in-from-bottom');
      
      // Force reflow
      void videoContainer.offsetWidth;
      
      videoContainer.classList.add(animClass);
      
      // Remove animation class after it completes
      setTimeout(function() {
        videoContainer.classList.remove(animClass);
        popupState.isAnimating = false;
      }, 400);
    }

    if (videoWrapper) videoWrapper.innerHTML = '';

    // Handle video
    if (sourceVideo && videoWrapper) {
      var videoClone = sourceVideo.cloneNode(true);
      videoClone.classList.remove('video-reels__video');
      videoClone.classList.add('video-reels-popup__video');
      videoClone.muted = false;
      videoClone.removeAttribute('autoplay');
      videoClone.currentTime = 0;
      
      videoWrapper.appendChild(videoClone);
      popupState.video = videoClone;

      if (muteBtn) {
        muteBtn.setAttribute('data-muted', 'false');
      }

      videoClone.play().then(function() {
        if (playBtn) playBtn.classList.add('is-playing');
      }).catch(function(err) {
        console.log('Popup autoplay prevented:', err);
        videoClone.muted = true;
        if (muteBtn) {
          muteBtn.setAttribute('data-muted', 'true');
        }
        videoClone.play().then(function() {
          if (playBtn) playBtn.classList.add('is-playing');
        }).catch(function() {});
      });

      setupProgressBar(popup, videoClone);

      videoClone.addEventListener('ended', function() {
        if (playBtn) playBtn.classList.remove('is-playing');
        // Auto-advance to next video when current one ends
        if (popupState.isOpen && popupState.totalSlides > 1) {
          setTimeout(function() {
            navigatePopup(popup, 1, 'down');
          }, 300);
        }
      });
    }

    // Handle product card - only show if product exists
    if (productWrapper) {
      productWrapper.innerHTML = '';
      
      // Check if source product card exists and has content
      if (sourceProductCard && sourceProductCard.innerHTML.trim() !== '') {
        var productClone = sourceProductCard.cloneNode(true);
        productWrapper.appendChild(productClone);
        productWrapper.style.display = '';
        productWrapper.classList.remove('is-hidden');
        
        var atcForm = productClone.querySelector('.video-reels-product-card__atc-form');
        if (atcForm) {
          atcForm.addEventListener('submit', handleAtc);
        }
      } else {
        // Hide the product wrapper if no product is selected
        productWrapper.style.display = 'none';
        productWrapper.classList.add('is-hidden');
      }
    }

    updateThumbnailActiveState(popup, index);
  }

  /* ───────────────────────────────────────────────────────────
     NAVIGATE POPUP - With direction for animation
  ─────────────────────────────────────────────────────────── */
  function navigatePopup(popup, direction, animDirection) {
    if (popupState.isAnimating) return;
    
    var newIndex = popupState.currentIndex + direction;
    
    if (newIndex < 0) {
      newIndex = popupState.totalSlides - 1;
    } else if (newIndex >= popupState.totalSlides) {
      newIndex = 0;
    }

    goToPopupSlide(popup, newIndex, animDirection);
  }

  /* ───────────────────────────────────────────────────────────
     GO TO SPECIFIC POPUP SLIDE - With animation direction
  ─────────────────────────────────────────────────────────── */
  function goToPopupSlide(popup, index, direction) {
    if (popupState.isAnimating) return;
    if (index === popupState.currentIndex) return;
    
    popupState.isAnimating = true;

    if (popupState.video) {
      popupState.video.pause();
    }

    if (popupState.animationFrame) {
      cancelAnimationFrame(popupState.animationFrame);
    }

    // Determine animation direction if not provided
    if (!direction) {
      direction = index > popupState.currentIndex ? 'down' : 'up';
    }

    popupState.currentIndex = index;
    
    updatePopupCounter(popup);
    loadPopupVideo(popup, index, direction);
  }

  /* ───────────────────────────────────────────────────────────
     UPDATE POPUP COUNTER
  ─────────────────────────────────────────────────────────── */
  function updatePopupCounter(popup) {
    var currentEl = popup.querySelector('[data-popup-current]');
    var totalEl = popup.querySelector('[data-popup-total]');
    
    if (currentEl) currentEl.textContent = popupState.currentIndex + 1;
    if (totalEl) totalEl.textContent = popupState.totalSlides;
  }

  /* ───────────────────────────────────────────────────────────
     UPDATE THUMBNAIL ACTIVE STATE
  ─────────────────────────────────────────────────────────── */
  function updateThumbnailActiveState(popup, index) {
    popup.querySelectorAll('[data-popup-thumb]').forEach(function(thumb, i) {
      thumb.classList.toggle('is-active', i === index);
    });
  }

  /* ───────────────────────────────────────────────────────────
     TOGGLE POPUP PLAY/PAUSE
  ─────────────────────────────────────────────────────────── */
  function togglePopupPlayPause(popup) {
    if (!popupState.video) return;

    var playBtn = popup.querySelector('[data-popup-play]');

    if (popupState.video.paused) {
      popupState.video.play().then(function() {
        if (playBtn) playBtn.classList.add('is-playing');
      }).catch(function() {});
    } else {
      popupState.video.pause();
      if (playBtn) playBtn.classList.remove('is-playing');
    }
  }

  /* ───────────────────────────────────────────────────────────
     TOGGLE POPUP MUTE
  ─────────────────────────────────────────────────────────── */
  function togglePopupMute(popup) {
    if (!popupState.video) return;

    var muteBtn = popup.querySelector('[data-popup-mute]');

    popupState.video.muted = !popupState.video.muted;
    
    if (muteBtn) {
      muteBtn.setAttribute('data-muted', popupState.video.muted ? 'true' : 'false');
    }
  }

  /* ───────────────────────────────────────────────────────────
     SETUP PROGRESS BAR
  ─────────────────────────────────────────────────────────── */
  function setupProgressBar(popup, video) {
    var progressBar = popup.querySelector('[data-popup-progress]');
    if (!progressBar) return;

    progressBar.style.width = '0%';

    function updateProgress() {
      if (video && video.duration && !isNaN(video.duration) && video.duration > 0) {
        var percent = (video.currentTime / video.duration) * 100;
        progressBar.style.width = percent + '%';
      }
      
      if (popupState.isOpen && video && !video.paused && !video.ended) {
        popupState.animationFrame = requestAnimationFrame(updateProgress);
      }
    }

    video.addEventListener('play', function() {
      if (popupState.animationFrame) {
        cancelAnimationFrame(popupState.animationFrame);
      }
      updateProgress();
    });

    video.addEventListener('pause', function() {
      if (popupState.animationFrame) {
        cancelAnimationFrame(popupState.animationFrame);
      }
    });

    video.addEventListener('seeked', function() {
      if (video.duration && !isNaN(video.duration) && video.duration > 0) {
        var percent = (video.currentTime / video.duration) * 100;
        progressBar.style.width = percent + '%';
      }
    });

    video.addEventListener('timeupdate', function() {
      if (video.duration && !isNaN(video.duration) && video.duration > 0) {
        var percent = (video.currentTime / video.duration) * 100;
        progressBar.style.width = percent + '%';
      }
    });

    video.addEventListener('ended', function() {
      progressBar.style.width = '100%';
      if (popupState.animationFrame) {
        cancelAnimationFrame(popupState.animationFrame);
      }
    });

    video.addEventListener('loadedmetadata', function() {
      if (video.currentTime > 0) {
        var percent = (video.currentTime / video.duration) * 100;
        progressBar.style.width = percent + '%';
      }
    });
  }

  /* ───────────────────────────────────────────────────────────
     VERTICAL SWIPE SUPPORT FOR MOBILE (Instagram Reels Style)
  ─────────────────────────────────────────────────────────── */
  function initVerticalSwipeSupport(popup) {
    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var videoContainer = popup.querySelector('.video-reels-popup__content');
    
    if (!videoContainer) return;

    videoContainer.addEventListener('touchstart', function(e) {
      if (popupState.isAnimating) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTime = Date.now();
    }, { passive: true });

    videoContainer.addEventListener('touchmove', function(e) {
      if (popupState.isOpen) {
        var diffY = startY - e.touches[0].clientY;
        if (Math.abs(diffY) > 10) {
          e.preventDefault();
        }
      }
    }, { passive: false });

    videoContainer.addEventListener('touchend', function(e) {
      if (popupState.isAnimating) return;
      
      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var diffX = startX - endX;
      var diffY = startY - endY;
      var timeDiff = Date.now() - startTime;
      
      var velocityY = Math.abs(diffY) / timeDiff;
      
      if (Math.abs(diffY) > Math.abs(diffX)) {
        var isValidSwipe = Math.abs(diffY) > 40 || (Math.abs(diffY) > 20 && velocityY > 0.3);
        
        if (isValidSwipe) {
          if (diffY > 0) {
            navigatePopup(popup, 1, 'down');
          } else {
            navigatePopup(popup, -1, 'up');
          }
        }
      }
    }, { passive: true });
  }

  /* ───────────────────────────────────────────────────────────
     MOUSE WHEEL SUPPORT FOR DESKTOP
  ─────────────────────────────────────────────────────────── */
  function initMouseWheelSupport(popup) {
    var videoContainer = popup.querySelector('.video-reels-popup__content');
    var lastWheelTime = 0;
    var wheelThreshold = 500;
    
    if (!videoContainer) return;

    videoContainer.addEventListener('wheel', function(e) {
      if (!popupState.isOpen || popupState.isAnimating) return;
      
      var now = Date.now();
      if (now - lastWheelTime < wheelThreshold) return;
      
      e.preventDefault();
      
      if (Math.abs(e.deltaY) > 30) {
        lastWheelTime = now;
        
        if (e.deltaY > 0) {
          navigatePopup(popup, 1, 'down');
        } else {
          navigatePopup(popup, -1, 'up');
        }
      }
    }, { passive: false });
  }

  /* ───────────────────────────────────────────────────────────
     PLAY VIDEO IN A SPECIFIC SLIDE (Auto-play - always muted)
  ─────────────────────────────────────────────────────────── */
  function playVideoInSlide(slideEl) {
    if (!slideEl) return;
    
    if (slideEl.classList.contains('splide__slide--clone')) {
      return;
    }

    var video = slideEl.querySelector('.video-reels__video');
    var playBtn = slideEl.querySelector('[data-play-btn]');
    var soundBtn = slideEl.querySelector('[data-sound-btn]');
    var poster = slideEl.querySelector('[data-video-poster]');

    if (!video) return;

    // Auto-play always starts muted (browser requirement)
    video.muted = true;
    
    // Update sound button state to reflect muted
    if (soundBtn) {
      soundBtn.dataset.muted = 'true';
    }

    // Reset video if ended
    if (video.ended) {
      video.currentTime = 0;
    }

    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(function () {
          if (playBtn) playBtn.classList.add('is-playing');
          slideEl.classList.add('is-playing');
          // Hide poster when video starts playing
          if (poster) {
            poster.classList.add('is-hidden');
          }
        })
        .catch(function (err) {
          console.log('Autoplay prevented:', err);
          if (playBtn) playBtn.classList.remove('is-playing');
          slideEl.classList.remove('is-playing');
          // Keep poster visible if autoplay fails
          if (poster) {
            poster.classList.remove('is-hidden');
          }
        });
    }
  }

  /* ───────────────────────────────────────────────────────────
     AUTO-PLAY THE ACTIVE (CENTER) SLIDE'S VIDEO
  ─────────────────────────────────────────────────────────── */
  function autoPlayActiveSlide(sliderEl) {
    if (popupState.isOpen) return;

    var activeSlide = sliderEl.querySelector('.splide__slide.is-active:not(.splide__slide--clone)');
    
    if (!activeSlide) {
      var activeSlides = sliderEl.querySelectorAll('.splide__slide.is-active');
      for (var i = 0; i < activeSlides.length; i++) {
        if (!activeSlides[i].classList.contains('splide__slide--clone')) {
          activeSlide = activeSlides[i];
          break;
        }
      }
    }

    if (!activeSlide) {
      return;
    }

    playVideoInSlide(activeSlide);
  }

  /* ───────────────────────────────────────────────────────────
     TOGGLE PLAY/PAUSE - Preserves mute state and handles poster
  ─────────────────────────────────────────────────────────── */
  function togglePlay(video, btn) {
    var slide = video.closest('.video-reels__slide');
    var soundBtn = slide ? slide.querySelector('[data-sound-btn]') : null;
    var poster = slide ? slide.querySelector('[data-video-poster]') : null;
    
    if (video.paused) {
      // Preserve the current mute state - don't force mute on manual play
      video.play()
        .then(function() {
          btn.classList.add('is-playing');
          if (slide) slide.classList.add('is-playing');
          // Hide poster when playing
          if (poster) poster.classList.add('is-hidden');
        })
        .catch(function(err) {
          // If play fails (rare for manual click), try muted as fallback
          console.log('Play failed, trying muted:', err);
          video.muted = true;
          if (soundBtn) {
            soundBtn.dataset.muted = 'true';
          }
          video.play()
            .then(function() {
              btn.classList.add('is-playing');
              if (slide) slide.classList.add('is-playing');
              if (poster) poster.classList.add('is-hidden');
            })
            .catch(function() {
              btn.classList.remove('is-playing');
              if (slide) slide.classList.remove('is-playing');
              // Keep poster visible if play fails
              if (poster) poster.classList.remove('is-hidden');
            });
        });
    } else {
      video.pause();
      btn.classList.remove('is-playing');
      if (slide) slide.classList.remove('is-playing');
      // Show poster when paused
      if (poster) poster.classList.remove('is-hidden');
    }
  }

  /* ───────────────────────────────────────────────────────────
     TOGGLE SOUND
  ─────────────────────────────────────────────────────────── */
  function toggleSound(video, btn) {
    video.muted = !video.muted;
    btn.dataset.muted = video.muted ? 'true' : 'false';
  }

  /* ───────────────────────────────────────────────────────────
     PAUSE ALL VIDEOS IN THIS SLIDER
     Resets sound state to muted and shows posters
  ─────────────────────────────────────────────────────────── */
  function pauseAllInSlider(sliderEl) {
    sliderEl.querySelectorAll('.video-reels__slide').forEach(function(slide) {
      var video = slide.querySelector('.video-reels__video');
      var poster = slide.querySelector('[data-video-poster]');
      
      if (video) {
        if (!video.paused) {
          video.pause();
        }
        video.muted = true;
      }
      
      // Show poster when video is paused
      if (poster) {
        poster.classList.remove('is-hidden');
      }
      
      // Remove playing class
      slide.classList.remove('is-playing');
    });
    
    // Reset play button states
    sliderEl.querySelectorAll('[data-play-btn]').forEach(function (b) {
      b.classList.remove('is-playing');
    });
    
    // Reset sound button states to muted
    sliderEl.querySelectorAll('[data-sound-btn]').forEach(function (b) {
      b.dataset.muted = 'true';
    });
  }

  /* ───────────────────────────────────────────────────────────
     RESET ALL SOUND STATES - Ensures all videos are muted
     and all sound buttons show muted state
  ─────────────────────────────────────────────────────────── */
  function resetAllSoundStates(sliderEl) {
    // Mute all videos
    sliderEl.querySelectorAll('.video-reels__video').forEach(function(video) {
      video.muted = true;
    });
    
    // Reset all sound buttons to muted state
    sliderEl.querySelectorAll('[data-sound-btn]').forEach(function(btn) {
      btn.dataset.muted = 'true';
    });
  }

  /* ───────────────────────────────────────────────────────────
     ADD TO CART (AJAX)
  ─────────────────────────────────────────────────────────── */
  function handleAtc(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var btn = form.querySelector('.video-reels-product-card__atc-btn');
    var idInput = form.querySelector('[name="id"]');
    var id = idInput ? idInput.value : null;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? qtyInput.value : 1;

    if (!id || !btn || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: id, quantity: parseInt(qty, 10) }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        refreshCartCount();
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  /* ───────────────────────────────────────────────────────────
     REFRESH CART COUNT BADGE
  ─────────────────────────────────────────────────────────── */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ───────────────────────────────────────────────────────────
     INTERSECTION OBSERVER
  ─────────────────────────────────────────────────────────── */
  function initVisibilityObserver() {
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.video-reels-section');
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var slider = entry.target.querySelector('.video-reels__splide');
          if (!slider) return;

          if (!entry.isIntersecting) {
            pauseAllInSlider(slider);
          } else if (!popupState.isOpen) {
            setTimeout(function() {
              autoPlayActiveSlide(slider);
            }, 200);
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach(function (sec) { observer.observe(sec); });
  }

  /* ───────────────────────────────────────────────────────────
     BOOT
  ─────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      initVisibilityObserver();
    });
  } else {
    init();
    initVisibilityObserver();
  }
})();